import { Chat } from "../../types/chat";
import { ChatActions } from "./types";

export function chats(state: {[id: string]: Chat} = {}, action: ChatActions) {
    switch(action.type) {
        case 'chats/fetch-success':
        case 'chats/create-success':
            if (action.data.entities.chats) {
                return { ...state, ...action.data.entities.chats }
            }
            return state;

        case 'chats/chat-notification':
            return {
                ...state,
                [action.data.id]: action.data
            }

        default:
            return state;
    }
}